import React, { PureComponent } from 'react';
import Bouncer from '@bit/bit.gui.generic-bouncer';
import { Platform } from '@bit/bit.gui.atoms.brick-3d';
import styles from './big-loader.module.css';
import config from '../../../config';
import { absCenterClass } from '../../abs-center';

export function BigLoader({ topFace, midFace }: { topFace?: any; midFace?: any }) {
	return (
		<div className={styles.background}>
			<div className={styles.loader}>
				<Bouncer size={64} className="margin-center">
					<Platform size={64} background="#fb507b" />
					<Platform size={64} background="#25e1a3">
						{midFace}
					</Platform>
					<Platform size={64} background="#8acfff">
						{topFace}
					</Platform>
				</Bouncer>
				<div className={styles.bigLoaderText}>
					<LoaderText />
				</div>
			</div>
		</div>
	);
}

class LoaderText extends PureComponent {
	state = {
		text: 'Loading playground...',
	};

	componentDidMount() {
		if (config.feature_bonusLoaderTexts) {
			const rndIdx = Math.floor(Math.random() * hardCoreTexts.length);
			const rndText = hardCoreTexts[rndIdx];

			this.setState({
				text: rndText,
			});
		}
	}
	render() {
		return this.state.text;
	}
}

const hardCoreTexts = [
	'molding Capsule...',
	'injecting nano-bits...',
	'formulating bits...',
	'clapping for blog posts...',
	'statring Bit Container...',
	'injecting Component into Capsule...',
	'injecting Capsule into Container...',
	'formulating formulas',
	'encapsulating code capsulations...',
	'summoning code platform...',
	'hiring Indians to write this demo...',
	'hiring Bulgarians to write this demo...',
	'hiring speed boats...',
	'fueling speed boats...',
	'hiring Americans to write this demo...',
	'fetching moon rocks...',
	'training monkeys to render components...',
	'spicing sauce...',
	'making contract with Sumalian pirates... for a pirate themed party',
	'throwing ball...',
	'fetching ball...',
	'Hiring Bill Murray',
	'applying special permission from the Office of Silly Walks',
	'remember: buy extra batteries for your flashlight',
	'take a deep breath',
	"You're a super-hot ninja machine!",
	'baking code...',
	'calculating rotational vectors..',
	'did you know you can use import statements?',
	'elevating platforms',
	'requesting fresh Capsule..',
	'nothing beats a fresh Capsule',
	'I love the smell of Capsule in the morning',
	'did you know cats are made of catponents?',
	'feeding dogs...',
	'applying mayonnaise...',
	'generating T.U.K.O projections..',
	'going live in Tokyo...',
	'cut off one head, and two more shall take its place',
	'I did everything he did, but backwards and in high heels!',
	"in bit heaven, there's a fresh serving of hummus every day",
	'in bit heaven, the coliforms sit at the Highest of Heavens',
];
